import { assignLegacyPlanIds } from './instructorPlanTier';
import { formatPlanLabel } from '../admin/Packages/planDisplayUtils';

const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/**
 * Normalizes instructor_plan_pricing rows for paywall cards.
 * Entitlements array is authoritative for limits and features.
 */
function normalizePricingRow(row) {
  const monthlyCents = Number(row.monthlyCents) || 0;
  const annualCents = Number(row.annualCents) || 0;
  const entitlements = Array.isArray(row.entitlements) ? row.entitlements : [];

  return {
    tier: row.tier,
    name: row.name || formatPlanLabel(row.tier),
    monthlyCents,
    annualCents,
    currency: row.currency || 'usd',
    entitlements,
    /** Checkout helper — monthly dollars when a listed price exists. */
    price: monthlyCents > 0 ? monthlyCents / 100 : 0,
  };
}

/**
 * Loads instructor tier pricing from instructor_plan_pricing (DB-authoritative).
 */
export async function fetchInstructorPlanPricing() {
  const response = await fetch(`${apiUrl}/api/instructor/plans/pricing`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
  });
  if (!response.ok) {
    throw new Error(`Instructor pricing request failed: ${response.status}`);
  }
  const rows = await response.json();
  if (!Array.isArray(rows)) {
    return [];
  }
  return rows.map(normalizePricingRow);
}

/**
 * Paywall catalog — instructor_plan_pricing only (no legacy package table).
 */
export async function fetchInstructorPaywallPackages() {
  const pricing = await fetchInstructorPlanPricing();
  if (!pricing.length) {
    return [];
  }
  return assignLegacyPlanIds(pricing);
}
